import React, { useState, useEffect } from "react";
import { useLocation, Switch, Redirect, useHistory } from "react-router-dom";
import GARemoteCommandJobDetails from "./job-details/GARemoteCommandJobDetails";
import GARemoteCommandCreateJob from "./create-job/GARemoteCommandCreateJob";

import { TabView, TabPanel } from "primereact/tabview";
import { useSelector } from "react-redux";

const GARemoteCommand = () => {
	const [activeIndex, setActiveIndex] = useState(0);
	const { pathname } = useLocation();
	const history = useHistory();

	const userRoles = useSelector((state) => state.profile.userRoles);

	useEffect(() => {
		if (pathname === "/admin/grafana-agent/server/job-details") {
			setActiveIndex(0);
		} else if (
			pathname === "/admin/grafana-agent/server/create-job"
		) {
			setActiveIndex(1);
		}
	}, [pathname]);

	const handleTabChange = (e) => {
		if (e.index === 0) {
			setActiveIndex(0);
			history.push("/admin/grafana-agent/server/job-details");
		} else if (e.index === 1) {
			setActiveIndex(1);
			history.push("/admin/grafana-agent/server/create-job");
		}
	};

	return (
		<div style={{ width: "100%" }}>
			<p className="page-label" style={{ padding: "22px 18px 0 18px" }}>
				Grafana Agent Remote Command
			</p>
			<TabView
				activeIndex={activeIndex}
				onTabChange={handleTabChange}
				className="container-fluid"
			>
				<TabPanel header="View Job">
					<GARemoteCommandJobDetails />
				</TabPanel>
				{userRoles.includes("GARemoteCommand.Write") && (
					<TabPanel header="Create Job">
						<GARemoteCommandCreateJob />
					</TabPanel>
				)}
			</TabView>
			<Switch>
				<Redirect
					exact
					path="/admin/grafana-agent"
					to="/admin/grafana-agent/server/job-details"
				/>
			</Switch>
		</div>
	);
};

export default GARemoteCommand;
